<template>
  <section
    v-if="isEditing"
    class="container my-spacing-base tablet:my-spacing-md"
  >
    Close the editor to render the Ostendis Jobs widget.
  </section>
  <section
    v-else
    id="ostendisJobs"
    class="container my-spacing-base tablet:my-spacing-md"
  >
    <ClientOnly>
      <div id="ostendisJobs" class="ost-jobs" />
    </ClientOnly>
  </section>
</template>

<script lang="ts" setup>
const { isEditing } = defineBlokkliFragment({
  name: 'ostendis_jobs',
  label: 'Ostendis Jobs',
  chunkName: 'rare',
  editor: {
    noPreview: true,
  },
})
if (import.meta.client) {
  const { onLoaded } = useScript({
    src: 'https://odm.ostendis.com/ojp/assets/loader',
    integrity:
      'sha384-5b5wkUwcE8WHpVL/Nv+0GlCAmaHiLlYU3xehBaxgs7txsDqu/mcoRIsutbpt84w+',
    crossorigin: 'anonymous',
    id: 'ostendisLoader',
    defer: true,
    'data-token': '8eadec771b5249eb90ea1e6b3446d179',
  })

  onLoaded(() => {
    document.addEventListener('ostendisLoaderReady', () => {
      if (window.OSTENDISJOBS) {
        window.OSTENDISJOBS.embed(
          '8eadec771b5249eb90ea1e6b3446d179', // publication place hash
          'DE', // jobpublisher language
          '#ostendisJobs', // css selector of container
          {}, // view options, default
        )
      }
    })
  })
}
</script>

<style lang="postcss" scoped>
.ost-jobs .action {
  color: orange;
  background-color: antiquewhite;
}
</style>
